

import axios from 'axios';
const { Login, GET_OTP, VERIFY_OTP, GETDASHBOARD_METRICS, GET_PROFITABLE_STRATEGIES, GET_STRATEGIES_ME, GET_MARKETPLACE, GET_PENDING, GET_PROFILE, GET_PNL_CHART } = require("../Utils/Url");

const api = axios.create({
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const GetOtp =(data)=>{
  return api.post(GET_OTP, data);
}
export const VerifyOtp =(data)=>{
  return api.post(VERIFY_OTP, data);
}

export const DashboardMetrics=()=>{
  return api.post(GETDASHBOARD_METRICS);
}
export const ProfitableStrategies=()=>{
  return api.post(GET_PROFITABLE_STRATEGIES);
}

export const MyStrategies = () => {
  return api.post(GET_STRATEGIES_ME);
}

export const MarketPlace = () => {
  return api.post(GET_MARKETPLACE);
}

export const Pending = () => {
  return api.post(GET_PENDING);
}


export const PnlChart = () => {
  return api.post(GET_PNL_CHART);
}